import { Navigate, useLocation } from 'react-router-dom'

/** AI Agent configuration moved to Agents → Settings. */
export default function ConfigurationRedirect() {
  const { search } = useLocation()
  return <Navigate to={`/agents/settings${search}`} replace />
}
